"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Chip = _interopRequireDefault(require("@material-ui/core/Chip"));

var _styles = require("@material-ui/styles");

var _Label = _interopRequireDefault(require("@material-ui/icons/Label"));

var _uiThemes = require("@hackoregon/ui-themes");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var secondary = _uiThemes.BrandColors.secondary;
var useStyles = (0, _styles.makeStyles)({
  tag: function tag(props) {
    var style = {};

    if (props.color) {
      style.color = props.color;
    } else {
      style.color = secondary.hex;
    }

    return style;
  },
  chip: {
    margin: "3px"
  }
});

function Chip(_ref) {
  var tag = _ref.tag,
      color = _ref.color,
      clickable = _ref.clickable;
  var classes = useStyles({
    color: color
  });
  return _react["default"].createElement(_Chip["default"], {
    label: "#".concat(tag),
    icon: _react["default"].createElement(_Label["default"], {
      className: classes.tag
    }),
    size: "small",
    clickable: clickable,
    className: classes.chip
  });
}

Chip.propTypes = {
  tag: _propTypes["default"].string,
  color: _propTypes["default"].string,
  clickable: _propTypes["default"].bool
};
var _default = Chip;
exports["default"] = _default;